// @flow

import * as React from "react";
import classNames from "classnames";
import MarkOfTrustImg from "./images/mark_of_trust.png";
import "./main-footer.style.scss";

type Props = $Exact<{
  className?: string,
}>;

export const MainFooter = (props: Props) => (
  <div className={classNames("main-footer", props.className)}>
    <div className="d-flex justify-content-center">
      <div className="image-container">
        <img className="w-100" src={MarkOfTrustImg} alt="iso" />
      </div>
    </div>
  </div>
);

export default MainFooter;
